import { useContext, useEffect, useState } from "react";
import { tableData } from "./tableData";
import { Container, ContainerScreenGeneral, MuniSpinner2, ScreenHeader, Table } from "../../components";
import { useActasStore } from "../../store/actasStore";
import { useGeneralAppStore } from "../../store/generalAppStore";

import { toast } from "react-toastify";
import { toastOptions } from "../../config/toast";
import { useActaDetalleStore } from "../../store/actaDetalleStore";
import ModalsOpcionesActas from "../../views/modals";
import ActaDetalle from "./ActaDetalle";
import { useNotificadores } from "../../hooks/useNotificadores";
import HeaderActas from "./components/HeaderActas";
import FilterBar from "./components/FilterBar";
import ActionsBar from "./components/ActionsBar";
import { useFilterActas } from "../../store/filterActasStore";
import { getActasHandler } from "../../handlers/actas.handler";
import { createWatchedObject } from "../../utils/watchObject";
import { Button, Form } from "react-bootstrap";
import ModalRangoFecha from "../../views/modals/ModalRangoFecha";
import ModalImprimirActas from "../../views/modals/ModalImprimirActas";
import ModalAsignarActas from "../../views/modals/ModalAsignarActas";
import ModalNotificadoresTable from "../../views/modals/ModalNotificadoresTable";
import ModalDesasignar from "../../views/modals/ModalDesasignar";
import ModalDesasignarActa from "../../views/modals/ModalDesasignarActa";
import useActas from "../../api/actas";

const Actas = ({ titulo, pathActas, estado_id, estados }) => {

  //TODO ESTADOS GLOBALES
  //TODO  ------------------------------------------------------------------------------------------
  const { loads, modals, handlerModal } = useGeneralAppStore();
  const { actas, actasFilter, setActasFilter, codigosZonales, codigosForaneos, setActaAImprimir, actaAImprimir, setActas, cleanActas } = useActasStore();
  const { cleanStore, actaDetalle, coleccionActasDetalle, setAllActaDetalle, } = useActaDetalleStore();
  const { filterFields, orderBy, paginateCfg } = useFilterActas();

  const {
    getActaChequear,
    getActaDetalle,
    quitarNotificadorAsignado
  } = useActas();

  //^ ESTADOS LOCALES
  //^  ------------------------------------------------------------------------------------------
  const [order, setOrder] = useState("asc");
  const [orderField, setOrderField] = useState("fecha_hora");
  const [filtersFileds, setFiltersField] = useState({ fecha_hora: "", });
  const [actasAImprimir, setActasAImprimir] = useState([]);
  const [notificador, setNotificador] = useState();
  const [actasAsignar, setActasAsignar] = useState([]);
  const [actaADesasignar, setActaADesasignar] = useState();
  const [refetch, setRefetch] = useState()
  const [actasLocale, setActasLocale] = useState();
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 100 });
  const [isFilterChange, setIsFilterChange] = useState(false);

  const [activeImprimir, setActiveImprimir] = useState(false);
  const [activeAsignar, setActiveAsignar] = useState(false);




  //~ HOOKS
  //~  ------------------------------------------------------------------------------------------
  const { getActas, imprimirActas, asignarActasANotificador } = useActas();
  const { getNotificadores } = useNotificadores()
  const { setFilterFields, returnResetFilterFields } = useFilterActas()

  //& KEYS
  //& -----------------------------------------------------------------------------------------
  const loadKeys = [
    "asignar_notificador",
    "acta_detalle",
    "desasignar_notificador",
    "marcar_impresa",
    // "actas",
    "notificadores",
    // "get_actas"
  ];




  const handlePaginationChange = (model) => {
    setPaginationModel(model);
  };

  useEffect(() => {
    if (estado_id == 2) {
      getNotificadores()
    }
    return () => {
      cleanStore();
      cleanActas();
    };
  }, [estado_id]);

  useEffect(() => {
    // setPaginationModel({ page: 0, pageSize: 100 });
    if (filterFields && filterFields !== null) {
      setIsFilterChange(true); // Marcar que el cambio es por filterFields
      setPaginationModel({ page: 0, pageSize: 100 }); // Cambiar la página a la primera
      const timer = setTimeout(() => {
        // Realizar la petición al backend solo si los filtros cambiaron
        getActasHandler(
          setActasLocale,
          { page: 0, pageSize: 100 },
          // paginationModel,
          {
            filtros: filterFields,
            estado_id: estados,
            order: orderBy,
            per_page: paginationModel.pageSize
          }
        );
      }, 750); // 2 segundos de espera
      return () => clearTimeout(timer);
    }
  }, [filterFields])


  useEffect(() => {
    // setPaginationModel({ page: 0, pageSize: 100 });
    if (refetch) {
      // Realizar la petición al backend solo si los filtros cambiaron
      getActasHandler(
        setActasLocale,
        { page: 0, pageSize: 100 },
        // paginationModel,
        {
          filtros: filterFields,
          estado_id: estados,
          order: orderBy,
          per_page: paginationModel.pageSize
        }
      );
    }
    setRefetch(false)
  },
    [refetch])


  useEffect(() => {
    // Aquí se llama a la API de inmediato cuando cambian la página o el orden
    if (!isFilterChange) {
      getActasHandler(
        setActasLocale,
        paginationModel,
        {
          filtros: filterFields,
          estado_id: estados,
          order: orderBy,
          per_page: paginationModel.pageSize
        }
      );
    } else {
      setIsFilterChange(false); // Reiniciar el flag después de la actualización de filterFields
    }
  }, [paginationModel, orderBy]); // Esto se ejecutará inmediatamente cuando cambie la página o el orden

  useEffect(() => {
    return () => {
      returnResetFilterFields();
    }
  }, [])

  return (
    <>
      <ContainerScreenGeneral titulo={titulo} linkBack={'/menu-actas'} size={'full'} >
        <div className="position-relative  z-1">
          {
            loadKeys.some(key => {
              if (key == "actas") {
                return false
              } else {
                return loads.includes(key)
              }
            }) &&
            <div className="position-absolute w-100 h-100  d-flex justify-content-center align-items-center z-2" style={{ backgroundColor: "rgba(255,255,255,0.7)" }}>
              <MuniSpinner2 />
            </div>
          }
          <HeaderActas
            estados={estados}
            actas={actas}
            actasFilter={actasFilter}
            filterFields={filterFields}
            actasLocale={actasLocale}
            activeImprimir={activeImprimir}
            setActiveImprimir={setActiveImprimir}
            activeAsignar={activeAsignar}
            setActiveAsignar={setActiveAsignar}
            actasAImprimir={actasAImprimir}
            setActasAImprimir={setActasAImprimir}
            notificador={notificador}
            setNotificador={setNotificador}
            actasAsignar={actasAsignar}
            setActasAsignar={setActasAsignar}
          />

          <Table
            className={` ${activeImprimir ? 'border-2 border-primary' : activeAsignar ? 'border-2 border-warning' : 'border-2 border-secondary-subtle'}`}
            height={750}
            maxHeight={'85vh'}
            columnHeaderHeight={75}
            bgHeader={"#1134C9"}
            minHeightFooter={"75px"}
            colorHeader={"#FFF"}
            loading={loads.includes('get_actas')}
            data={tableData(actasLocale, setFiltersField, setOrder, setOrderField, estado_id, setActaAImprimir, setActaADesasignar)}

            paginationMode="server"
            paginationModel={paginationModel}
            onPaginationModelChange={handlePaginationChange}
            rowCount={paginateCfg?.total || 0}

            rowClick={(params) => {
              if (!activeImprimir && !activeAsignar) {
                const actaDetalle = coleccionActasDetalle?.find(
                  (acta) => acta?.acta.id == params?.row?.id
                );
                if (actaDetalle) {
                  setAllActaDetalle(actaDetalle);
                  handlerModal({ modal: true, modalName: "acta_detalle" });
                } else {
                  if (estado_id == 3) {
                    getActaChequear(params?.row?.id);
                  } else {
                    getActaDetalle(params?.row?.id);
                  }
                }
              }
            }}
            renderButtonFooter={() =>
              estado_id == 3 || estado_id == 4 ? (
                <Form.Group>
                  <Form.Label className="m-0 w-100 text-center" style={{ fontSize: "0.8rem" }}>
                    Domicilio electronico
                  </Form.Label>
                  <Form.Check

                    name="domicilio_notificacion_id"
                    onChange={(e) => {
                      setFilterFields(e.target.name, e.target.checked);
                      // setFiltersField((prevState) => ({
                      //   ...prevState,
                      //   [e.target.name]: e.target.checked,
                      // }));
                    }
                    }
                  ></Form.Check>
                </Form.Group>
              )
                //  : estado_id == 10 ? (
                //   <Form.Group className="d-flex flex-column align-items-center">
                //     <Button
                //       onClick={() => handlerModal({ modal: true, modalName: "modal_imprimir_actas" })}
                //       disabled={actasAImprimir.length == 0 || loadKeys.some(key => loads.includes(key))} style={{ minWidth: "83px" }}>
                //       <span className="m-0 fw-light">{actasAImprimir.length} Actas para imprimir</span>
                //     </Button>
                //   </Form.Group>
                // )
                // : estado_id == 2 ? (
                //   <div className="d-flex align-items-center gap-4">
                //     <Form.Group className="d-flex flex-column align-items-center ">
                //       <Form.Label className="m-0 w-100 text-center" style={{ fontSize: "0.8rem" }}>
                //         Notificador
                //       </Form.Label>
                //       <Button
                //         onClick={() => handlerModal({ modal: true, modalName: "notificadores_table" })}
                //         disabled={(actasAImprimir.length != 0)} style={{ minWidth: "83px" }}><span className="m-0 fw-light">{notificador?.nombre || "Seleccione notificador"}</span></Button>
                //     </Form.Group>
                //     {notificador?.nombre &&
                //       <Form.Group className="d-flex flex-column align-items-center ">
                //         <Form.Label className="m-0 w-100 text-center" style={{ fontSize: "0.8rem" }}>
                //           Asginar
                //         </Form.Label>
                //         <Button
                //           onClick={() => { handlerModal({ modal: true, modalName: "modal_asignar_actas" }) }}
                //           disabled={(actasAsignar.length == 0)} style={{ minWidth: "83px" }}><span className="m-0 fw-light">{actasAsignar?.length} Actas</span></Button>
                //       </Form.Group>
                //     }
                //   </div>
                // )
                  :
                  estado_id == 15 ? (
                    <Form.Group>
                      <Form.Label className="m-0 w-100 text-center" style={{ fontSize: "0.8rem" }}>
                        Actas tribunales marcadas
                      </Form.Label>
                      <Form.Check

                        name="baja_tribunal"
                        onChange={(e) => {

                          setFilterFields(e.target.name, e.target.checked);
                        }
                        }
                      ></Form.Check>
                    </Form.Group>
                  )
                    : null
            }

            name="actas"
            // search
            onCellClick={(a, { target }) => {
              if (estado_id == 10 && activeImprimir) {
                if (a.field === 'actions') {
                  return
                }
                // if (actasAImprimir.includes(a.row.id)) {
                if (actasAImprimir.find((acta) => acta.id == a.row.id)) {
                  const newActasAsignadas = actasAImprimir.filter((acta) => acta?.id != a.row.id)
                  setActasAImprimir(newActasAsignadas);
                } else {
                  setActasAImprimir((prevState) => [...prevState, a.row])
                }

              }
              if (estado_id == 2 && activeAsignar) {
                if (a.field === 'actions') {
                  return
                }
                if (!notificador) {
                  toast.error('Debe serleccionar un notificador para asignarle actas', toastOptions)
                  return
                }
                // if (actasAsignar.includes(a.row.id)) {
                if (actasAsignar.find((acta) => acta.id == a.row.id)) {
                  const newActasAsignadas = actasAsignar.filter((acta) => acta?.id != a.row.id)
                  setActasAsignar(newActasAsignadas);
                } else {
                  // setActasAsignar((prevState) => [...prevState, a.row.id])
                  setActasAsignar((prevState) => [...prevState, a.row])
                }
              }
            }}


            getRowClassName={
              estado_id == 10 ? ({ row }) => {
                // if (actasAImprimir.includes(row.id)) {
                if (actasAImprimir.find((acta) => acta.id == row.id)) {
                  return 'imprimir'
                } else if (row.dependencia == 'MCD') {
                  return 'mcd'
                }
                return ''
              } : estado_id == 2 ? ({ row }) => {
                // if (actasAsignar.includes(row.id)) {
                if (actasAsignar.find((acta) => acta.id == row.id)) {
                  return 'asignado'
                } else if (row.dependencia == 'MCD') {
                  return 'mcd'
                }
              } : estado_id == 3 ? ({ row }) => {
                if (row.domicilio_notificacion_id) {

                  return 'tieneDomicilio'
                }
                return ''
              } : estado_id == 15 ? ({ row }) => {
                if (row.baja_tribunal == 1) {
                  return 'bajaTribunal'
                } else if (row.dependencia == 'MCD') {
                  return 'mcd'
                }
              }
                :
                ({ row }) => {
                  if (row.dependencia == 'MCD') {
                    return 'mcd'
                  } else {
                    return null

                  }
                }
            }

            sx={{
              ".MuiDataGrid-row.mcd": {
                backgroundColor: '#F4C75B',
                color: "#111"
              },
              ".MuiDataGrid-row.imprimir": {
                backgroundColor: '#5A7DFF',
                color: "white"
              },
              ".MuiDataGrid-row.asignado": {
                backgroundColor: '#FFD54F',
                color: "#111"
              },
              ".MuiDataGrid-row.bajaTribunal": {
                backgroundColor: '#111',
                color: "white"
              },
              ".MuiDataGrid-row.tieneDomicilio": {
                backgroundColor: '#198754',
                color: "white"
              },
              ".MuiDataGrid-row.Mui-hovered": {
                backgroundColor: '#D6D6D6',
              },
              ".MuiDataGrid-row.Mui-hovered.MuiDataGrid-row.imprimir": {
                backgroundColor: '#1934ad',
                color: "white"
              },
              ".MuiDataGrid-row.Mui-hovered.MuiDataGrid-row.asignado": {
                backgroundColor: '#FFC107',
                color: "#111"
              },
              ".MuiDataGrid-row.Mui-hovered.MuiDataGrid-row.mcd": {
                backgroundColor: '#D3A93D',
                color: "#111"
              },
              ".MuiDataGrid-row.Mui-hovered.MuiDataGrid-row.bajaTribunal": {
                backgroundColor: '#202020',
                color: "white"
              },
            }}
          />
          {/* } */}

        </div>
        {modals.includes("rango_fecha") && <ModalRangoFecha setFiltersField={setFiltersField} />}
        {modals.includes("modal_imprimir_actas") && <ModalImprimirActas setFiltersField={setFiltersField} actasAImprimir={actasAImprimir} setActasAImprimir={setActasAImprimir} setRefetch={setRefetch} />}
        {modals.includes("modal_asignar_actas") && <ModalAsignarActas notificador={notificador} actasAsignar={actasAsignar} setActasAsignar={setActasAsignar} setRefetch={setRefetch} />}
        {modals.includes("notificadores_table") && <ModalNotificadoresTable modals={modals} setNotificador={setNotificador} handlerModal={handlerModal} />}
        {modals.includes("modal_desasignar_acta") && <ModalDesasignarActa modals={modals} actaADesasignar={actaADesasignar} handlerModal={handlerModal} setRefetch={setRefetch} />}

        {actaDetalle &&
          <ModalsOpcionesActas setRefetch={setRefetch} />
        }

      </ContainerScreenGeneral>
    </>
  );
};
export default Actas;
